import z from 'zod';

import { emptyChildren } from './commons';
import { ELEMENT_TYPES } from './constants';
import { BlueskyCodec } from './elements/Bluesky';
import { CrossheadCodec } from './elements/Crosshead';
import { CustomJsonCodec } from './elements/CustomJson';
import { DynamicTeaserCodec } from './elements/DynamicTeaser';
import { EmbeddedContentCodec } from './elements/EmbeddedContent';
import { FacebookCodec } from './elements/Facebook';
import { FooterCodec } from './elements/Footer';
import { FrontendComponentCodec } from './elements/FrontendComponent';
import { ImageCodec } from './elements/Image';
import { InfoboxCodec } from './elements/Infobox';
import { InstagramCodec } from './elements/Instagram';
import { InterviewSegmentCodec } from './elements/InterviewSegment';
import { LeadCodec } from './elements/Lead';
import { OrderedListCodec, UnorderedListCodec } from './elements/List';
import { ParagraphCodec } from './elements/Paragraph';
import { PollCodec } from './elements/Poll';
import { QuoteCodec } from './elements/Quote';
import { RatingPollCodec } from './elements/RatingPoll';
import { SeparatorCodec } from './elements/Separator';
import { CsSlideshowCodec, SlideshowCodec } from './elements/Slideshow';
import { EmbeddedSnippetCodec, SnippetCodec } from './elements/Snippet';
import { SummaryCodec } from './elements/Summary';
import { ThreadsCodec } from './elements/Threads';
import { TiktokCodec } from './elements/Tiktok';
import { TitleCodec } from './elements/Title';
import { TitleHeaderCodec } from './elements/TitleHeader';
import { TwitterCodec } from './elements/Twitter';
import { VideoCmsCodec } from './elements/VideoCms';
import { YoutubeCodec } from './elements/Youtube';
import { ZattooCodec } from './elements/Zattoo';
import { createElement } from '../creators/createElement';

const ElementCodecs = z.discriminatedUnion(
    'type',
    [
        CrossheadCodec,
        FacebookCodec,
        FooterCodec,
        InstagramCodec,
        LeadCodec,
        OrderedListCodec,
        UnorderedListCodec,
        SeparatorCodec,
        TitleCodec,
        TitleHeaderCodec,
        TwitterCodec,
        QuoteCodec,
        PollCodec,
        RatingPollCodec,
        InterviewSegmentCodec,
        DynamicTeaserCodec,
        SummaryCodec,
        InfoboxCodec,
        ImageCodec,
        ParagraphCodec,
        BlueskyCodec,
        EmbeddedContentCodec,
        EmbeddedSnippetCodec,
        SnippetCodec,
        FrontendComponentCodec,
        CustomJsonCodec,
        SlideshowCodec,
        CsSlideshowCodec,
        ThreadsCodec,
        TiktokCodec,
        VideoCmsCodec,
        YoutubeCodec,
        ZattooCodec,
    ],
    { unionFallback: true },
);

export const RichTextCodec = z.codec(
    z.object({
        richTextFormat: z.array(ElementCodecs),
    }),
    z.array(ElementCodecs),
    {
        decode: (value) => {
            if (value.richTextFormat.length === 0) {
                return [
                    ElementCodecs.encode(
                        createElement(ELEMENT_TYPES.PARAGRAPH, { children: emptyChildren }),
                    ),
                ];
            }

            return value.richTextFormat.map((element) => ElementCodecs.encode(element));
        },
        encode: (value) => ({
            richTextFormat: value.map((element) => ElementCodecs.decode(element)),
        }),
    },
);
